module.exports = __webpack_public_path__ + "img/faq13.634381ad.png";